export enum ConversationFilterIds {
  screeningStatus = 'screeningStatus',
  applicationStage = 'applicationStage',
  meetingBookingStatus = 'meetingBookingStatus',
  status = 'status',
  control = 'control'
}

export enum SortFields {
  lastActivity = 'lastActivity',
  replies = 'replies',
  score = 'score'
}

export enum ScreeningStatusFilter {
  PROGRESSED = 'PROGRESSED',
  REJECTED = 'REJECTED',
  NOT_INTERESTED = 'NOT_INTERESTED',
  INCOMPLETE = 'INCOMPLETE',
  OPTED_OUT = 'OPTED_OUT'
}

export enum ConversationStatusFilter {
  REVIEW = 'REVIEW',
  MORE_TIME_REQUESTED = 'MORE_TIME_REQUESTED',
  CREATED = 'CREATED',
  ONGOING = 'ONGOING',
  OPTED_OUT = 'OPTED_OUT',
  QUEUED = 'QUEUED',
  CLOSED = 'CLOSED',
  NOT_DELIVERED = 'NOT_DELIVERED'
}

export enum MeetingFilter {
  NO_MEETING = 'NO_MEETING'
}

export enum ControlFilter {
  MANUAL = 'MANUAL',
  AI = 'AI'
}

// Mirrors messaging-service's NeedsReviewReason. The backend field is
// [String!] (the GraphQL enum was deprecated in PAD-5398), so codegen only
// exposes MORE_TIME_REQUESTED; the full value set lives here for FE use.
export enum UnresolvedNeedsReviewReason {
  MORE_TIME_REQUESTED = 'MORE_TIME_REQUESTED',
  ASKED_FOR_HUMAN = 'ASKED_FOR_HUMAN',
  UNANSWERED_QUESTION = 'UNANSWERED_QUESTION',
  SPECIAL_NEEDS_REQUEST = 'SPECIAL_NEEDS_REQUEST',
  OUT_OF_OFFICE = 'OUT_OF_OFFICE',
  HUMAN_TAKEOVER = 'HUMAN_TAKEOVER',
  CLOSED_CONVERSATION_REPLY = 'CLOSED_CONVERSATION_REPLY',
  AVAILABILITY_NOT_FOUND = 'AVAILABILITY_NOT_FOUND',
  CONTENT_MODERATION = 'CONTENT_MODERATION',
  OTHER = 'OTHER'
}
